import { getAssetsUrlBase } from '../../../core/models/common/static_resource_util';

export class LenCountAction {
  static LenCount(event: Event) {
    const target = event.target as HTMLInputElement;
    const maxlength = target.maxLength;
    const strlen = target.value.length;
    const number = maxlength - strlen;
    if (target.id === 'makername' || target.id === 'productname' || target.id === 'makermodel') {
      LenCountAction.checkDisabled();
      LenCountAction.checkIsEmpty(target);
    }
    (document.getElementById(`${target.id}_number`) as HTMLElement).innerText = `残り${number < 0? 0 : number}文字`;
  }

  static reset() {
    ['makername', 'productname', 'makermodel', 'jancode', 'comment'].forEach((id) => {
      const target = <HTMLInputElement>document.getElementById(id);
      target.value = '';
      LenCountAction.checkDisabled();
      LenCountAction.clearError(target);
    });
  }

  private static checkDisabled() {
    const btnItemRequest = document.getElementById('btn_item_request') as HTMLElement;
    if (
      LenCountAction.hasInput('makername') &&
      LenCountAction.hasInput('productname') &&
      LenCountAction.hasInput('makermodel')
    ) {
      btnItemRequest.classList.remove('is-disabled');
    } else {
      btnItemRequest.classList.add('is-disabled');
    }
  }

  private static hasInput(id: string) {
    return (document.getElementById(id) as HTMLInputElement).value.length > 0;
  }

  private static checkIsEmpty(target: HTMLInputElement) {
    const wrapper = document.getElementById(`${target.id}_wrapper`) as HTMLElement;
    if (target.value.length) {
      wrapper.classList.remove('is-error');
      this.showIcon(target, 'icon_check_circle_green');
    } else {
      wrapper.classList.add('is-error');
      this.showIcon(target, 'icon_attention_red');
    }
  }

  private static showIcon(target: HTMLInputElement, iconFileName: string) {
    const icon = document.getElementById(`${target.id}_icon`) as HTMLImageElement;
    icon.style.display = 'block';
    icon.src = `${getAssetsUrlBase()}images/${iconFileName}.svg`;
  }

  private static clearError(target: HTMLInputElement) {
    (document.getElementById(`${target.id}_wrapper`) as HTMLElement)?.classList.remove('is-error');
    (document.getElementById(`${target.id}_number`) as HTMLElement).innerText = '';
    LenCountAction.clearIcon(target);
  }

  private static clearIcon(target: HTMLInputElement) {
    const icon = document.getElementById(`${target.id}_icon`) as HTMLImageElement;
    if (icon) {
      icon.style.display = 'none';
      icon.src = '';
    }
  }
}
